import React from 'react';

import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { ScrollOffset as BaseScrollOffset } from '~/techstyle-shared/react-components';

const ScrollOffsetWrapper = styled(BaseScrollOffset)`
  ${({ theme }) => theme.pdpScrollOffset};
`;

const ScrollOffset = React.forwardRef(
  ({ children, offsetOverride = false, ...rest }, ref) => {
    const theme = useTheme();

    const { mobile, desktop } = theme.header.height;
    const desktopOffset = offsetOverride ? 0 : desktop;
    const mobileOffset = offsetOverride ? 0 : mobile;

    return (
      <ScrollOffsetWrapper
        offset={desktopOffset}
        mobileOffset={mobileOffset}
        {...rest}
        ref={ref}
      >
        {children}
      </ScrollOffsetWrapper>
    );
  }
);

ScrollOffset.displayName = BaseScrollOffset.displayName;

ScrollOffset.propTypes = {
  children: PropTypes.node,
  offsetOverride: PropTypes.bool,
};

export default ScrollOffset;
